import { Category } from '../types/category';

/**
 * Get category name in the specified language with fallback to English
 */
export const getCategoryName = (category: Category, language: string): string => {
  switch (language) {
    case 'zh':
      return category.nameZh || category.name;
    case 'cn':
      return category.nameCn || category.name;
    default:
      return category.name;
  }
};

/**
 * Get category description in the specified language with fallback to English
 */
export const getCategoryDescription = (category: Category, language: string): string => {
  switch (language) {
    case 'zh':
      return category.descriptionZh || category.description;
    case 'cn':
      return category.descriptionCn || category.description;
    default:
      return category.description;
  }
};
